import { useQuery } from '@tanstack/react-query';
import { hierarchyFilterOptionsQueryOptions } from '@/features/leaveApplications/api/leaveApplications.api';
import { HIERARCHY_FILTER_TYPE } from '@/features/leaveApplications/constants/leaveApplication.constants';
import { useAmFilterOptions } from './useAmFilterOptions';

interface UseAmZmFilterOptionsParams {
  isEnabled: boolean;
  amUserId: number | undefined;
}

export function useAmZmFilterOptions({ isEnabled, amUserId }: UseAmZmFilterOptionsParams) {
  const { amOptions, hasAmOptionsError } = useAmFilterOptions(isEnabled);
  const { data: zmOptions, isError: hasZmOptionsError } = useQuery({
    ...hierarchyFilterOptionsQueryOptions(HIERARCHY_FILTER_TYPE.ZM, amUserId),
    enabled: isEnabled,
  });

  return {
    amOptions,
    zmOptions,
    hasOptionsError: hasAmOptionsError || hasZmOptionsError,
  };
}
